import {
  CommentsResponse,
  EditorialCreateBody,
  EditorialItem,
  EditorialListResponse,
  FileUploadResponse,
  VendorProductListResponse,
} from "utils/api/client/types"

export class Editorials {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    body: EditorialCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<EditorialItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/articles`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(id: string, body: EditorialCreateBody): Promise<EditorialItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/articles/${id}`, {
        method: "PUT",
        body,
      })
    })()
  }

  list(
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<EditorialListResponse> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/articles`, {
        headers,
        query: queryParams,
      })
    })()
  }

  retrieve(id: string): Promise<EditorialItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/articles/${id}`)
    })()
  }

  vendorProducts(
    searchKey: string,
    vendorId: string
  ): Promise<VendorProductListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/p_products?q=${searchKey}&offset=0&limit=20&vendor_id=${vendorId}`
      )
    })()
  }

  delete(id: string, headers?: Record<string, unknown>): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/articles/${id}`, {
        method: "DELETE",
        headers,
      })
    })()
  }

  listComment(
    editorialId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<CommentsResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/articles/${editorialId}/comments`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  deleteComment(editorialId: string, commentId: string) {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/articles/${editorialId}/comments/${commentId}`,
        {
          method: "DELETE",
        }
      )
    })()
  }

  createImage(payload: { image: File }): Promise<FileUploadResponse> {
    return (async () => {
      const body = new FormData()
      body.append("image", payload.image)
      return await (this.client as any).fetch(`/admin/articles/image`, {
        method: "POST",
        headers: {
          "content-type": null,
        },
        body,
      })
    })()
  }
}
